import { InboxOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Select, Typography, Upload } from "antd";
import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addDocument } from "../../redux/rtk/features/document/documentSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const { Dragger } = Upload;
const { Title } = Typography;
const { Option } = Select;

const UserDocument = ({ drawer }) => {
    const [forms, setForms] = useState([{ key: Date.now(), thumbFileList: [] }]);
    const dispatch = useDispatch();
    const userId = getUserFromToken();

    const handleFileUpload = (key, fileList) => {
        // console.log("fileList", fileList)
        // console.log("key", key)
        setForms((prevForms) =>
            prevForms.map((form) =>
                form.key === key ? { ...form, thumbFileList: fileList } : form
            )
        );
    };

    const handleAddForm = () => {
        setForms((prevForms) => [...prevForms, { key: Date.now(), thumbFileList: [] }]);
    };

    const handleRemoveForm = (key) => {
        setForms((prevForms) => prevForms.filter((form) => form.key !== key));
    };

    const onFinish = async () => {
        const formData = forms.map((form) => {
            const documentOf = 'user'
            const payload = {
                ...form.values,
                userId,
                documentProof: form.thumbFileList[0]?.originFileObj,
                documentOf: documentOf,
            };
            // console.log("Prepared Payload:", payload);
            return payload;
        });
    
        // console.log("Submitting Documents:", JSON.stringify(formData, null, 2));
    
        for (const data of formData) {
            const resp = await dispatch(addDocument(data));
            if (resp.payload.message !== "success") {
                toast.error(`Failed to submit document: ${data.documentName}`);
                return;
            }
        }
    
        toast.success("All documents submitted successfully!");
        setForms([{ key: Date.now(), thumbFileList: [] }]); // Reset forms
    };
    

    const onFormValuesChange = (key, changedValues) => {
        setForms((prevForms) =>
            prevForms.map((form) =>
                form.key === key ? { ...form, values: { ...form.values, ...changedValues } } : form
            )
        );
    };

    return (
        <Fragment>
            <UserPrivateComponent permission={"create-leaveApplication"}>
                <Row className="mr-top" justify="center">
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={drawer ? 22 : 16}
                        xl={drawer ? 22 : 12}
                        className="column-design border rounded card-custom"
                    >
                        <Title level={4} className="m-2 mt-5 mb-5 text-center">
                            Add Documents
                        </Title>
                        {forms.map((form) => (
                            <Form
                                key={form.key}
                                style={{ marginBottom: "40px" }}
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 12 }}
                                onValuesChange={(changedValues) => onFormValuesChange(form.key, changedValues)}
                            >
                                <Form.Item
                                    label="Document Type"
                                    name="documentType"
                                    rules={[{ required: true, message: "Please select the document type" }]}
                                >
                                    <Select placeholder="Select a document type">
                                        <Select.Option value="Aadhar">Aadhar</Select.Option>
                                        <Select.Option value="PAN">PAN</Select.Option>
                                        <Select.Option value="10th Certificate">10th Certificate</Select.Option>
                                        <Select.Option value="12th Certificate">12th Certificate</Select.Option>
                                        <Select.Option value="Other">Other</Select.Option>
                                    </Select>
                                </Form.Item>

                                {/* <Form.Item
                                    label="Document Name"
                                    name="documentName"
                                    rules={[{ required: true, message: "Please enter the document name" }]}
                                >
                                    <Input />
                                </Form.Item> */}

                                {form.values?.documentType === "Expired Document" && (
                                    <Form.Item
                                        label="Expire Date"
                                        name="expireDate"
                                        rules={[{ required: true, message: "Please select the expire date" }]}
                                    >
                                        <DatePicker />
                                    </Form.Item>
                                )}

                                <Form.Item
                                    label="Upload Document"
                                    required={true}
                                >
                                    <Dragger
                                        listType="picture-card"
                                        beforeUpload={() => false}
                                        name="documentProof"
                                        fileList={form.thumbFileList}
                                        onChange={({ fileList }) => handleFileUpload(form.key, fileList)}
                                        maxCount={1}
                                    >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-hint">
                                            Support for a single upload. Strictly prohibited from uploading
                                            company data or other banned files.
                                        </p>
                                    </Dragger>
                                </Form.Item>

                                {forms.length > 1 && (
                                    <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
                                        <Button
                                            danger
                                            onClick={() => handleRemoveForm(form.key)}
                                            block
                                        >
                                            Remove
                                        </Button>
                                    </Form.Item>
                                )}
                            </Form>
                        ))}

                        <Row justify="center" style={{ marginBottom: "20px" }}>
                            <Button type="dashed" onClick={handleAddForm} icon={<InboxOutlined />}>
                                Add Another Document
                            </Button>
                        </Row>

                        <Row justify="center">
                            <Button
                                type="primary"
                                size="large"
                                onClick={onFinish}
                                block
                            >
                                Save Documents
                            </Button>
                        </Row>
                    </Col>
                </Row>
            </UserPrivateComponent>
        </Fragment>
    );
};

export default UserDocument;
